var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33389 4.9966L0.247787 9.09649C0.0652942 9.28086 0.0652941 9.57964 0.248407 9.76369C0.326795 9.84297 0.44856 9.88743 0.582099 9.88743H0.582719C0.715328 9.88743 0.835854 9.84266 0.913623 9.76432L5.00035 5.66411L9.08645 9.76432C9.25222 9.93096 9.5856 9.93034 9.75136 9.76463C9.83997 9.67602 9.88862 9.55756 9.88862 9.43134C9.88738 9.30511 9.83935 9.18572 9.75074 9.09618L5.66463 4.99722L9.75105 0.8964C9.83904 0.807792 9.88862 0.689338 9.88862 0.5628C9.88862 0.436884 9.83904 0.318429 9.75043 0.2292C9.59427 0.0728149 9.24168 0.072815 9.088 0.228578L5.00035 4.32909L0.912074 0.2292C0.756227 0.0718822 0.404564 0.0721931 0.248407 0.2292C0.159174 0.318429 0.11084 0.437194 0.11084 0.56311C0.11084 0.689337 0.159484 0.807792 0.247787 0.895778L4.33389 4.9966Z",
    fill: "#4DB6AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.3e9a9674.svg";
export { ForwardRef as ReactComponent };